<template>
  <div class="body-wrapper">
    <Headernav />
    <div class="header-banner-wrapper section">
      <div class="container md:flex items-center">
        <div class="w-full lg:w-6/12">
          <div class="banner-title text-white mb-3">More Than 40 Years of Operation Thru Quality Service To Clients</div>
          <div class="yelow-border mb-10"></div>
          <a href="#contact-area" v-smooth-scroll="{ duration: 2500}"><div class="red-btn">Inquire Now</div></a>
        </div>
        <div class="w-full lg:w-6/12">
          <img class="m-auto" src="/images/banner-image.png">
        </div>
      </div>
    </div>
    <div class="content-wrapper">
      <div class="w-full section">
        <div class="container">
          <div class="w-full text-center mb-8">
            <div class="section-title text-gray-800">Guardland Brand Fire Extinguisher</div>
            <div class="text-common text-2xl md:text-3xl lg:text-3xl leading-normal text-indigo-500">The Brand You Can Trust!</div>
          </div>
          <div class="w-full">
            <no-ssr> <!-- important to add no-ssr-->
            <carousel
              class="w-full" :autoHeight="true" :autoplay="true" :autoplayTimeout="5000" :dots="true" :loop="true" :nav="false" :rewind="true" :responsive="{
                0: {
                  items: 1
                },
                640: {
                  items: 2,
                  margin: 20
                },
                768: {
                  items: 2,
                  margin: 30
                }
              }"
              >
                <div class="products-container">
                  <img class="m-auto" src="/images/products/product_01.jpg" />
                  <div class="w-full bg-yellow-300 p-5">
                    <div class="text-title text-2xl leading-normal text-gray-800">DRY CHEMICAL</div>
                    <div class="text-common text-xl leading-normal text-gray-800">(mono-ammonium phosphate)</div>
                  </div>
                  <div class="w-full p-5">
                    <table cellpadding="0" cellspacing="0" class="w-full">
                      <tr>
                        <td valign="top" width="15px" class="pb-2"><img src="/images/bullet-icon.jpg" /></td>
                        <td valign="top" class="text-common pl-3 text-lg leading-normal text-gray-800 pb-2">Non-hazardous, non-toxic & non-conductor of electricity</td>
                      </tr>
                      <tr>
                        <td valign="top" width="15px" class="pb-2"><img src="/images/bullet-icon.jpg" /></td>
                        <td valign="top" class="text-common pl-3 text-lg leading-normal text-gray-800 pb-2">Pressurized type</td>
                      </tr>
                      <tr>
                        <td valign="top" width="15px" class="pb-2"><img src="/images/bullet-icon.jpg" /></td>
                        <td valign="top" class="text-common pl-3 text-lg leading-normal text-gray-800 pb-2">One-shot operation only</td>
                      </tr>
                      <tr>
                        <td valign="top" width="15px" class="pb-2"><img src="/images/bullet-icon.jpg" /></td>
                        <td valign="top" class="text-common pl-3 text-lg leading-normal text-gray-800 pb-2">15-20 ft maximum range</td>
                      </tr>
                      <tr>
                        <td valign="top" width="15px" class="pb-2"><img src="/images/bullet-icon.jpg" /></td>
                        <td valign="top" class="text-common pl-3 text-lg leading-normal text-gray-800 pb-2">Complete with wall attachment Effective for all classes of fire A,  B & C</td>
                      </tr>
                      <tr>
                        <td valign="top" width="15px" class="pb-2"><img src="/images/bullet-icon.jpg" /></td>
                        <td valign="top" class="text-common pl-3 text-lg leading-normal text-gray-800 pb-2">Available in 3, 5, 10, 15, 20 lbs & wheeled-type 50, 100, 150, 200 lbs capacity</td>
                      </tr>
                      <tr>
                        <td valign="top" width="15px" class="pb-2"><img src="/images/bullet-icon.jpg" /></td>
                        <td valign="top" class="text-common pl-3 text-lg leading-normal text-gray-800 pb-2">Free-flowing powder & residual</td>
                      </tr>
                    </table>
                  </div>
                </div>

                <div class="products-container">
                  <img class="m-auto" src="/images/products/product_02.jpg" />
                  <div class="w-full bg-yellow-300 p-5">
                    <div class="text-title text-2xl leading-normal text-gray-800">HCFC 123</div>
                    <div class="text-common text-xl leading-normal text-gray-800">(Dichlorotrifluoroethane)</div>
                  </div>
                  <div class="w-full p-5">
                    <table cellpadding="0" cellspacing="0" class="w-full">
                      <tr>
                        <td valign="top" width="15px" class="pb-2"><img src="/images/bullet-icon.jpg" /></td>
                        <td valign="top" class="text-common pl-3 text-lg leading-normal text-gray-800 pb-2">Clean & odorless extinguishing agent which leaves no residue thereby no mess after use</td>
                      </tr>
                      <tr>
                        <td valign="top" width="15px" class="pb-2"><img src="/images/bullet-icon.jpg" /></td>
                        <td valign="top" class="text-common pl-3 text-lg leading-normal text-gray-800 pb-2">Pressurized type with pressure gauge control</td>
                      </tr>
                      <tr>
                        <td valign="top" width="15px" class="pb-2"><img src="/images/bullet-icon.jpg" /></td>
                        <td valign="top" class="text-common pl-3 text-lg leading-normal text-gray-800 pb-2">Non-toxic & non-conductor of electricity so it is safe to use even with fires caused by electrical default</td>
                      </tr>
                      <tr>
                        <td valign="top" width="15px" class="pb-2"><img src="/images/bullet-icon.jpg" /></td>
                        <td valign="top" class="text-common pl-3 text-lg leading-normal text-gray-800 pb-2">15-20 ft maximum wide range</td>
                      </tr>
                      <tr>
                        <td valign="top" width="15px" class="pb-2"><img src="/images/bullet-icon.jpg" /></td>
                        <td valign="top" class="text-common pl-3 text-lg leading-normal text-gray-800 pb-2">Can be used to put all classes of fire A, B & C</td>
                      </tr>
                      <tr>
                        <td valign="top" width="15px" class="pb-2"><img src="/images/bullet-icon.jpg" /></td>
                        <td valign="top" class="text-common pl-3 text-lg leading-normal text-gray-800 pb-2">The presence of a sprinkler head makes it function in a dual operation as it operates automatically at 135-165 degrees Fahrenheit</td>
                      </tr>
                      <tr>
                        <td valign="top" width="15px" class="pb-2"><img src="/images/bullet-icon.jpg" /></td>
                        <td valign="top" class="text-common pl-3 text-lg leading-normal text-gray-800 pb-2">Available in 3lbs, 5lbs, 10lbs, 15lbs, 20lbs, 50lbs, 100lbs, 150lbs, 200lbs</td>
                      </tr>
                    </table>
                  </div>
                </div>

                <div class="products-container">
                  <img class="m-auto" src="/images/products/product_03.jpg" />
                  <div class="w-full bg-yellow-300 p-5">
                    <div class="text-title text-2xl leading-normal text-gray-800">AQUEOUS FILM FORMING FOAM</div>
                    <div class="text-common text-xl leading-normal text-gray-800">(AFFF)</div>
                  </div>
                  <div class="w-full p-5">
                    <table cellpadding="0" cellspacing="0" class="w-full">
                      <tr>
                        <td valign="top" width="15px" class="pb-2"><img src="/images/bullet-icon.jpg" /></td>
                        <td valign="top" class="text-common pl-3 text-lg leading-normal text-gray-800 pb-2">Direct stream of 30ft to 40ft maximum range</td>
                      </tr>
                      <tr>
                        <td valign="top" width="15px" class="pb-2"><img src="/images/bullet-icon.jpg" /></td>
                        <td valign="top" class="text-common pl-3 text-lg leading-normal text-gray-800 pb-2">Complete with wall attachment</td>
                      </tr>
                      <tr>
                        <td valign="top" width="15px" class="pb-2"><img src="/images/bullet-icon.jpg" /></td>
                        <td valign="top" class="text-common pl-3 text-lg leading-normal text-gray-800 pb-2">Utilizes the cooling, soaking and penetrating effect of water which makes it effective even for inexperienced operators for use on class A fires</td>
                      </tr>
                      <tr>
                        <td valign="top" width="15px" class="pb-2"><img src="/images/bullet-icon.jpg" /></td>
                        <td valign="top" class="text-common pl-3 text-lg leading-normal text-gray-800 pb-2">Effective for class A & B fires only</td>
                      </tr>
                      <tr>
                        <td valign="top" width="15px" class="pb-2"><img src="/images/bullet-icon.jpg" /></td>
                        <td valign="top" class="text-common pl-3 text-lg leading-normal text-gray-800 pb-2">Available in 2.5 liters, 1, 2, 25 gals & wheeled-type 5, 10, 15 & 20 gals</td>
                      </tr>
                      <tr>
                        <td valign="top" width="15px" class="pb-2"><img src="/images/bullet-icon.jpg" /></td>
                        <td valign="top" class="text-common pl-3 text-lg leading-normal text-gray-800 pb-2">Foam concentrate mixed with Water Pressurized Type</td>
                      </tr>
                      <tr>
                        <td valign="top" width="15px" class="pb-2"><img src="/images/bullet-icon.jpg" /></td>
                        <td valign="top" class="text-common pl-3 text-lg leading-normal text-gray-800 pb-2">Available in 3lbs, 5lbs, 10lbs, 15lbs, 20lbs, 50lbs, 100lbs, 150lbs, 200lbs</td>
                      </tr>
                    </table>
                  </div>
                </div>

                <div class="products-container">
                  <img class="m-auto" src="/images/products/product_04.jpg" />
                  <div class="w-full bg-yellow-300 p-5">
                    <div class="text-title text-2xl leading-normal text-gray-800">CARBON DIOXIDE</div>
                    <div class="text-common text-xl leading-normal text-gray-800">(CO2)</div>
                  </div>
                  <div class="w-full p-5">
                    <table cellpadding="0" cellspacing="0" class="w-full">
                      <tr>
                        <td valign="top" width="15px" class="pb-2"><img src="/images/bullet-icon.jpg" /></td>
                        <td valign="top" class="text-common pl-3 text-lg leading-normal text-gray-800 pb-2">Clean & odorless gas</td>
                      </tr>
                      <tr>
                        <td valign="top" width="15px" class="pb-2"><img src="/images/bullet-icon.jpg" /></td>
                        <td valign="top" class="text-common pl-3 text-lg leading-normal text-gray-800 pb-2">Colorless liquid/ gas or white solid in appearance which extinguishes fire by eliminating its oxygen</td>
                      </tr>
                      <tr>
                        <td valign="top" width="15px" class="pb-2"><img src="/images/bullet-icon.jpg" /></td>
                        <td valign="top" class="text-common pl-3 text-lg leading-normal text-gray-800 pb-2">Non-conductor of electricity</td>
                      </tr>
                      <tr>
                        <td valign="top" width="15px" class="pb-2"><img src="/images/bullet-icon.jpg" /></td>
                        <td valign="top" class="text-common pl-3 text-lg leading-normal text-gray-800 pb-2">Squeeze type complete with hose & horn</td>
                      </tr>
                      <tr>
                        <td valign="top" width="15px" class="pb-2"><img src="/images/bullet-icon.jpg" /></td>
                        <td valign="top" class="text-common pl-3 text-lg leading-normal text-gray-800 pb-2">Effective for class B (flammable liquids) & class C (electrical) fires</td>
                      </tr>
                      <tr>
                        <td valign="top" width="15px" class="pb-2"><img src="/images/bullet-icon.jpg" /></td>
                        <td valign="top" class="text-common pl-3 text-lg leading-normal text-gray-800 pb-2">Available in 10, 15, 20 lbs and wheeled-type 50 & 100 lbs</td>
                      </tr>
                    </table>
                  </div>
                </div>

                <div class="products-container">
                  <img class="m-auto" src="/images/products/product_05.jpg" />
                  <div class="w-full bg-yellow-300 p-5">
                    <div class="text-title text-2xl leading-normal text-gray-800">HFC 236FA</div>
                    <div class="text-common text-xl leading-normal text-gray-800">(Chemical Hexaflouropropane)</div>
                  </div>
                  <div class="w-full p-5">
                    <table cellpadding="0" cellspacing="0" class="w-full">
                      <tr>
                        <td valign="top" width="15px" class="pb-2"><img src="/images/bullet-icon.jpg" /></td>
                        <td valign="top" class="text-common pl-3 text-lg leading-normal text-gray-800 pb-2">Non corrosive</td>
                      </tr>
                      <tr>
                        <td valign="top" width="15px" class="pb-2"><img src="/images/bullet-icon.jpg" /></td>
                        <td valign="top" class="text-common pl-3 text-lg leading-normal text-gray-800 pb-2">Safer for people, assets and environment</td>
                      </tr>
                      <tr>
                        <td valign="top" width="15px" class="pb-2"><img src="/images/bullet-icon.jpg" /></td>
                        <td valign="top" class="text-common pl-3 text-lg leading-normal text-gray-800 pb-2">Non Corrosive, non-residue and has zero Ozone Depletion Potential (ODP)</td>
                      </tr>
                      <tr>
                        <td valign="top" width="15px" class="pb-2"><img src="/images/bullet-icon.jpg" /></td>
                        <td valign="top" class="text-common pl-3 text-lg leading-normal text-gray-800 pb-2">Suited for use in portable Fire Extinguishers for high value applications such as in computer areas, telecommunication facilities, and process and control rooms</td>
                      </tr>
                      <tr>
                        <td valign="top" width="15px" class="pb-2"><img src="/images/bullet-icon.jpg" /></td>
                        <td valign="top" class="text-common pl-3 text-lg leading-normal text-gray-800 pb-2">Clean & odorless gas</td>
                      </tr>
                      <tr>
                        <td valign="top" width="15px" class="pb-2"><img src="/images/bullet-icon.jpg" /></td>
                        <td valign="top" class="text-common pl-3 text-lg leading-normal text-gray-800 pb-2">Available in 3lbs, 5lbs, 10lbs, 15lbs, 20lbs, 50lbs, 100lbs, 150lbs & 200lbs wheeled-type</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </carousel>
            </no-ssr>
          </div>
        </div>
      </div>
      <div class="other-products-container section">
        <div class="container lg:flex">
          <div class="w-full lg:w-4/12 pb-6 lg:pb-0">
            <div class="section-title text-yellow-400 pb-5">Other Products</div>
            <table cellpadding="0" cellspacing="0">
              <tr>
                <td valine="top" class="text-2xl text-yellow-400 leading-normal"><i class="fas fa-caret-right"></i></td>
                <td valine="top" class="text-common pl-3 text-common leading-normal text-white">Fire Hose Cabinet</td>
              </tr>
              <tr>
                <td valine="top" class="text-2xl text-yellow-400 leading-normal"><i class="fas fa-caret-right"></i></td>
                <td valine="top" class="text-common pl-3 text-common leading-normal text-white">Fire Hoses</td>
              </tr>
              <tr>
                <td valine="top" class="text-2xl text-yellow-400 leading-normal"><i class="fas fa-caret-right"></i></td>
                <td valine="top" class="text-common pl-3 text-common leading-normal text-white">Angle Valve</td>
              </tr>
              <tr>
                <td valine="top" class="text-2xl text-yellow-400 leading-normal"><i class="fas fa-caret-right"></i></td>
                <td valine="top" class="text-common pl-3 text-common leading-normal text-white">Straight or Fog Nozzle</td>
              </tr>
              <tr>
                <td valine="top" class="text-2xl text-yellow-400 leading-normal"><i class="fas fa-caret-right"></i></td>
                <td valine="top" class="text-common pl-3 text-common leading-normal text-white">Fire Axe</td>
              </tr>
              <tr>
                <td valine="top" class="text-2xl text-yellow-400 leading-normal"><i class="fas fa-caret-right"></i></td>
                <td valine="top" class="text-common pl-3 text-common leading-normal text-white">Nipple</td>
              </tr>
              <tr>
                <td valine="top" class="text-2xl text-yellow-400 leading-normal"><i class="fas fa-caret-right"></i></td>
                <td valine="top" class="text-common pl-3 text-common leading-normal text-white">Automatic Emergency Lights</td>
              </tr>
              <tr>
                <td valine="top" class="text-2xl text-yellow-400 leading-normal"><i class="fas fa-caret-right"></i></td>
                <td valine="top" class="text-common pl-3 text-common leading-normal text-white">Smoke Alarm</td>
              </tr>
              <tr>
                <td valine="top" class="text-2xl text-yellow-400 leading-normal"><i class="fas fa-caret-right"></i></td>
                <td valine="top" class="text-common pl-3 text-common leading-normal text-white">Fire Exit Sign</td>
              </tr>
              <tr>
                <td valine="top" class="text-2xl text-yellow-400 leading-normal"><i class="fas fa-caret-right"></i></td>
                <td valine="top" class="text-common pl-3 text-common leading-normal text-white">Fireman’s Coats, Helmets, Gloves & Boots (sizes available)</td>
              </tr>
            </table>
          </div>
          <div class="w-full lg:w-8/12">
            <no-ssr> <!-- important to add no-ssr-->
              <carousel
                class="w-full"
                :autoHeight="true"
                :autoplay="true"
                :autoplayTimeout="5000"
                :dots="true"
                :loop="true"
                :nav="false"
                :rewind="true"
                :responsive="{
                  0: {
                    items: 1
                  },
                  640: {
                    items: 2,
                    margin: 20
                  },
                  768: {
                    items: 3,
                    margin: 20
                  }
                }"
              >
                <div class="text-center" v-for="(otherproduct, i) in otherproducts" :key="i">
                  <img class="border-2 border-orange-300" :src="otherproduct.file" :alt="otherproduct.file">
                </div>
              </carousel>
          </no-ssr>
          </div>
        </div>
      </div>
      <div class="w-full section">
        <div class="container lg:flex">
          <div class="w-full lg:w-6/12 pb-6 lg:pb-0">
            <img class="border-2 border-orange-300" src="/images/about-us-img.jpg" />
          </div>
          <div class="w-full lg:w-6/12">
            <div class="section-title text-gray-800 pb-5">About Us</div>
            <div class="text-common text-lg leading-normal text-gray-800 text-justify">
              The main product of Gaerlan Manufacturing, Inc. is fire extinguisher with Guardland as its product name. Guardland fire extinguishers are bought by big establishments in the Philippines. Gaerlan Manufacturing, Inc. caters to all private individuals and all types of business establishments – private and government.
              <br><br>
              The factory is situated at #17 Pangilinan Ave., Pangilinan Compound, Quezon City and is considered as one of the largest manufacturing areas for fire extinguishers. Its General Manager, Mr. Eduardo S. Gaerlan as well as its Assistant General Manager Ms. Ma. Lourdes C. Gaerlan, personally oversee the whole operation of the manufacturing concern. Both owners see to it that the commitment to quality is being translated into the work ethics of the workers in the firm.
            </div>
          </div>
        </div>
      </div>
      <div class="w-full">
        <div class="container border-b-2 border-gray-600 border-dashed"></div>
      </div>
      <div id="contact-area" class="w-full section">
        <div class="container">
          <div class="w-full p-8">
            <div class="w-full text-center section-title text-gray-800">Contact Us</div>
          </div>
          <div class="w-full lg:flex">
            <div class="w-full lg:w-5/12 pb-8 lg:pb-0">
              <div class="w-full flex pb-6">
                <div class="pr-5" style="width: 82px !important;"><img style="min-width: 72px;" src="/images/icon-map.jpg"></div>
                <div class="pt-2">
                  <div class="text-common text-xl leading-tight text-red-600">VISIT US</div>
                  <div class="text-common text-base leading-tight text-gray-800">17 Pangilinan Ave., Pangilinan Compound, Barangay Bahay Toro, Quezon City</div>
                </div>
              </div>
              <div class="w-full flex pb-6">
                <div class="pr-5" style="width: 82px !important;"><img style="min-width: 72px;" src="/images/icon-email.jpg"></div>
                <div class="pt-2">
                  <div class="text-common text-xl leading-tight text-red-600">EMAIL</div>
                  <a href="mailto:gaerlanmanufacturinginc@yahoo.com" class="text-common text-base leading-tight text-gray-800 transition-effect hover:text-blue-500 break-all pb-3">gaerlanmanufacturinginc@yahoo.com</a><br>
                  <a href="mailto:gaerlanmanufacturingincqc@gmail.com" class="text-common text-base leading-tight text-gray-800 transition-effect hover:text-blue-500 break-all">gaerlanmanufacturingincqc@gmail.com</a>
                </div>
              </div>
              <div class="w-full flex pb-6">
                <div class="pr-5" style="width: 82px !important;"><img style="min-width: 72px;" src="/images/icon-tel.jpg"></div>
                <div class="pt-2">
                  <div class="text-common text-xl leading-tight text-red-600">TELEPHONE</div>
                  <a href="tel:0289287439" class="text-common text-base leading-tight text-gray-800 transition-effect hover:text-blue-500 pb-3">(02) 8 928-7439</a><br>
                  <a href="tel:0289272149" class="text-common text-base leading-tight text-gray-800 transition-effect hover:text-blue-500 pb-3">(02) 8 927-2149</a><br>
                  <a href="tel:0289281014" class="text-common text-base leading-tight text-gray-800 transition-effect hover:text-blue-500 pb-3">(02) 8 928-1014</a>
                </div>
              </div>
              <div class="w-full flex pb-6">
                <div class="pr-5" style="width: 82px !important;"><img style="min-width: 72px;" src="/images/icon-mobile.jpg"></div>
                <div class="pt-2">
                  <div class="text-common text-xl leading-tight text-red-600">MOBILE</div>
                  <a href="tel:09625073969" class="text-common text-base leading-tight text-gray-800 transition-effect hover:text-blue-500 pb-3">09625073969 - Cathy</a><br>
                  <a href="tel:09061187958" class="text-common text-base leading-tight text-gray-800 transition-effect hover:text-blue-500 pb-3">09061187958 - Che</a><br>
                  <a href="tel:09954020959" class="text-common text-base leading-tight text-gray-800 transition-effect hover:text-blue-500 pb-3">09954020959 - Lenny</a><br>
                  <a href="tel:09456037199" class="text-common text-base leading-tight text-gray-800 transition-effect hover:text-blue-500 pb-3">09456037199 - Micka</a><br>
                  <a href="tel:09453052339" class="text-common text-base leading-tight text-gray-800 transition-effect hover:text-blue-500 pb-3">09453052339 - Rona</a><br>
                  <a href="tel:09070867150" class="text-common text-base leading-tight text-gray-800 transition-effect hover:text-blue-500 pb-3">09070867150- Daisy</a><br>
                  <a href="tel:09951712435" class="text-common text-base leading-tight text-gray-800 transition-effect hover:text-blue-500 pb-3">09951712435 - Noemi</a>
                </div>
              </div>
            </div>
            <div class="w-full lg:w-7/12">
              <!-- feedback.activamedia.com.sg script begins here -->
              <!-- <iframe allowTransparency="true" style="min-height:500px; height:inherit; overflow:visible;" width="100%" id="contactform123" name="contactform123" marginwidth="0" marginheight="0" frameborder="0" src="//feedback.activamedia.com.sg/my-contact-form-4564558.html">
                <p>Your browser does not support iframes. The contact form cannot be displayed. Please use another contact method (phone, fax etc)</p>
              </iframe> -->
              <!-- feedback.activamedia.com.sg script ends here -->

              <contactform />
            </div>
          </div>
        </div>
      </div>
      <div class="w-full">
        <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15438.834826593757!2d121.0390741!3d14.6724654!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x8fa9e09c1aa298b6!2sGaerlan%20Manufacturing%2C%20Incorporated!5e0!3m2!1sen!2sph!4v1582793193288!5m2!1sen!2sph" width="100%" height="450" frameborder="0" style="border:0;" allowfullscreen=""></iframe>
      </div>
    </div>
    <div class="footer-wrapper bg-gray-900">
      <div class="container text-center text-white">
        <div class="w-full">Maintained and Developed by AMPH Advertising Agency Inc.</div>
      </div>
    </div>
  </div>
</template>
<script>
import Headernav from '@/components/Headernav.vue'
import contactform from '@/components/contactform.vue'
import carousel from 'vue-owl-carousel'
import vueSmoothScroll from 'vue-smooth-scroll'
export default {
  components: {
    Headernav,
    contactform,
    vueSmoothScroll,
    carousel
  },
  data () {
    return {
      otherproducts: [
        {
          file: '/images/products/other_product_01.jpg'
        },
        {
          file: '/images/products/other_product_02.jpg'
        },
        {
          file: '/images/products/other_product_03.jpg'
        },
        {
          file: '/images/products/other_product_04.jpg'
        },
        {
          file: '/images/products/other_product_05.jpg'
        },
        {
          file: '/images/products/other_product_06.jpg'
        },
        {
          file: '/images/products/other_product_07.jpg'
        },
        {
          file: '/images/products/other_product_08.jpg'
        },
        {
          file: '/images/products/other_product_09.jpg'
        },
        {
          file: '/images/products/other_product_10.jpg'
        },
        {
          file: '/images/products/other_product_11.jpg'
        },
        {
          file: '/images/products/other_product_12.jpg'
        },
        {
          file: '/images/products/other_product_13.jpg'
        },
        {
          file: '/images/products/other_product_14.jpg'
        },
        {
          file: '/images/products/other_product_15.jpg'
        }
      ]
    }
  }
}
</script>
<style>
</style>
